import { useParams } from 'react-router-dom'
import React from 'react'
import { Typography } from '@mui/material'
import { com } from '@eidu/web'
import ImportEntitiesPage from '../ImportEntitiesPage'
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

const ImportPageRoute = () => {
  const params = useParams()

  if (params.entityTypeId) {
    return <ImportEntitiesPage entityTypeId={entityTypeIdFromString(params.entityTypeId)} />
  }

  return <Typography sx={{ padding: 3 }}>Unknown entity type</Typography>
}

export default ImportPageRoute
